import { createContext } from 'react';
import { DEFAULT_TENANT, ENVIRONMENT_CODES } from '../../constants';
const defaultValues = {
  environment: ENVIRONMENT_CODES.LIVE,
  tenant: DEFAULT_TENANT
};
export const environmentContext = /*#__PURE__*/createContext(defaultValues);
//# sourceMappingURL=environmentContext.js.map